import { IconMarketing } from '@/features/icons';
import { CardBadges } from '../constant';
interface Props {
  flags: string[] | undefined;
  isAd: boolean;
}
export const Flags = ({
  flags,
  isAd
}: Props) => {
  if (!flags?.length && !isAd) return null;
  return <div className='absolute right-0.5 top-1 z-10 flex w-full flex-wrap items-center gap-px lg:gap-0.5' data-sentry-component="Flags" data-sentry-source-file="flags.tsx">
            {isAd ? <div className='flex items-center justify-center gap-px rounded text-caption-10 text-primary-main lg:text-caption-12 lg:font-medium'>
                    <IconMarketing className='h-3 w-3 lg:h-4 lg:w-4' />
                    <span>آگهی</span>
                </div> : flags?.map(flag => {
      const item = CardBadges.find(({
        id
      }) => id === flag);
      if (!item) return null;
      return <div key={item.id} className='flex items-center justify-center gap-px rounded bg-gray-900 p-0.5 text-caption-10 text-text-white lg:gap-0.5 lg:py-0 lg:text-caption-12 lg:font-medium'>
                            <item.icon className='h-3 w-3 lg:h-4 lg:w-4' />
                            <span>{item.label}</span>
                        </div>;
    })}
        </div>;
};